import axios from 'src/utils/axios';

export const GET_ALL_LEAD = '@lead/get-all-lead';
export const ADD_LEAD = '@lead/add-lead';
export const UPDATE_LEAD = '@lead/update-lead';
export const DELETE_LEAD = '@lead/delete-lead';
export const GET_ONE_LEAD = '@lead/get-one-lead';
export const LAST_SEEN = '@lead/last-seen';
export const IMPORT_LEADS = '@lead/import-leads';

export function getAllLead(botId) {
  const request = axios.get(`/api/leads/all/${botId}`);

  return dispatch => {
    return request.then(response => {
      dispatch({
        type: GET_ALL_LEAD,
        payload: response.data
      });

      return response.data;
    });
  };
}
export function getOneLead(id) {
  const request = axios.get(`/api/leads/${id}`);

  return dispatch => {
    return request.then(response => {
      dispatch({
        type: GET_ONE_LEAD,
        payload: response.data
      });

      return response.data;
    });
  };
}

export function addOneLead(lead) {
  const request = axios.post(`/api/leads/add`, {
    lead
  });
  return dispatch => {
    request.then(response =>
      dispatch({
        type: ADD_LEAD,
        payload: response.data
      })
    );
  };
}

export function updateLead(lead) {
  const request = axios.put(`/api/leads/update`, {
    lead
  });
  return dispatch => {
    request.then(response =>
      dispatch({
        type: UPDATE_LEAD,
        payload: response.data
      })
    );
  };
}

export function deleteLead(id) {
  const request = axios.delete(`/api/leads/delete/${id}`);

  return dispatch => {
    request.then(() =>
      dispatch({
        type: DELETE_LEAD,
        payload: { id } //pasar id
      })
    );
  };
}

const IMPORT_BATCH_SIZE = 200;
const IMPORT_BATCH_BYTES = 75 * 1024;
const IMPORT_REQUEST_TIMEOUT = 20 * 1000;

function deduplicateImportLeads(leads, botId) {
  const leadsById = new Map();

  leads.forEach((lead, index) => {
    const phone = String(lead.telefono || '').trim();
    const channel = String(lead.channel || '')
      .trim()
      .toLowerCase();
    const id = `${phone}:${channel}:${botId}`;
    leadsById.set(id, { lead: { ...lead, channel }, row: index + 2 });
  });

  return {
    entries: Array.from(leadsById.values()).sort((a, b) => a.row - b.row),
    duplicates: leads.length - leadsById.size
  };
}

function createImportBatches(entries, botId) {
  const batches = [];
  let batch = [];

  entries.forEach(entry => {
    const candidate = [...batch, entry];
    const candidateBytes = new Blob([
      JSON.stringify({ leads: candidate.map(item => item.lead), botId })
    ]).size;

    if (
      batch.length > 0 &&
      (batch.length >= IMPORT_BATCH_SIZE ||
        candidateBytes > IMPORT_BATCH_BYTES)
    ) {
      batches.push({
        leads: batch.map(item => item.lead),
        rows: batch.map(item => item.row)
      });
      batch = [entry];
    } else {
      batch = candidate;
    }
  });

  if (batch.length > 0) {
    batches.push({
      leads: batch.map(item => item.lead),
      rows: batch.map(item => item.row)
    });
  }

  return batches;
}

export function importLeads(leads, botId, onProgress) {
  return async () => {
    const deduplicated = deduplicateImportLeads(leads, botId);
    const batches = createImportBatches(deduplicated.entries, botId);
    const result = {
      success: 0,
      failed: 0,
      duplicates: deduplicated.duplicates,
      errors: []
    };
    let processed = deduplicated.duplicates;

    try {
      for (const batch of batches) {
        const response = await axios.post(
          '/api/leads/import',
          { leads: batch.leads, botId },
          { timeout: IMPORT_REQUEST_TIMEOUT }
        );

        result.success += response.data.success || 0;
        result.failed += response.data.failed || 0;
        result.duplicates += response.data.duplicates || 0;
        result.errors.push(
          ...(response.data.errors || []).map(error => ({
            ...error,
            row: batch.rows[error.row - 2] || error.row
          }))
        );

        processed += batch.leads.length;
        if (onProgress) {
          onProgress({ processed, total: leads.length });
        }
      }
    } catch (error) {
      error.importResult = result;
      throw error;
    }

    return result;
  };
}
